export default "__VITE_ASSET__BI$I0z9W__"